/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISSlide = {
    readonly id?: number;
    readonly block_obj_id?: number;
    readonly lab_order_id?: number;
    readonly stain_id?: number;
    /**
     * original filename of the slide from the scanner
     */
    name?: string | null;
    lis_state?: LISSlide.lis_state | null;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    readonly updated_at?: string;
    readonly created_at?: string;
    is_control?: boolean;
    is_rescan?: boolean;
}

export namespace LISSlide {

    export enum lis_state {
        UNSTAINED = 'unstained',
        RACKED = 'racked',
        STAINED = 'stained',
        SCANNING = 'scanning',
        SCANNED = 'scanned',
    }


}
